import Alert from "@cloudscape-design/components/alert"
import MissingFieldsList, {
  type ValidationError,
} from "../../../components/shared/MissingFieldsList"

interface ValidationErrorsAlertProps {
  /**
   * Validation errors blocking a publish. Populated only after a failed Submit-for-Review attempt;
   * empty renders nothing.
   */
  errors: ValidationError[]
  /**
   * Clears the errors when the alert is dismissed.
   */
  onDismiss: () => void
  /**
   * Navigates the editor to the tab/field of a clicked error.
   */
  onErrorClick: (tab: string, field: string) => void
}

/**
 * Blocking validation errors from a failed Submit-for-Review, rendered as an inline dismissible
 * alert near the top of the page. This is the one message that can legitimately sit at the top, and
 * only transiently (it only populates after a failed submit). Each error is a click-to-field link
 * that navigates the editor to the offending field.
 */
const ValidationErrorsAlert = ({ errors, onDismiss, onErrorClick }: ValidationErrorsAlertProps) => {
  if (errors.length === 0) return null

  return (
    <div className="dta-validation-alert" data-testid="validation-errors">
      <Alert
        type="error"
        dismissible
        dismissAriaLabel="Dismiss validation errors"
        onDismiss={onDismiss}
        header="Cannot submit for review - required fields are missing"
      >
        <MissingFieldsList errors={errors} onErrorClick={onErrorClick} />
      </Alert>
    </div>
  )
}

export default ValidationErrorsAlert
